/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DiscoverServersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DiscoverServersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DiscoverServersSecurity = {
  option1?: DiscoverServersSecurityOption1 | undefined;
  option2?: DiscoverServersSecurityOption2 | undefined;
};

export type DiscoverServersRequest = {
  includeDeleted?: boolean | undefined;
  /**
   * Unsupported: any supplied value returns 400
   */
  updatedSince?: string | undefined;
  /**
   * Search query; at most 1024 UTF-8 bytes, enforced by the server (not a character count).
   */
  search?: string | undefined;
  /**
   * Version filter; at most 1024 UTF-8 bytes, enforced by the server (not a character count).
   */
  version?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DiscoverServersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DiscoverServersSecurityOption1$outboundSchema: z.ZodMiniType<
  DiscoverServersSecurityOption1$Outbound,
  DiscoverServersSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function discoverServersSecurityOption1ToJSON(
  discoverServersSecurityOption1: DiscoverServersSecurityOption1,
): string {
  return JSON.stringify(
    DiscoverServersSecurityOption1$outboundSchema.parse(
      discoverServersSecurityOption1,
    ),
  );
}

/** @internal */
export type DiscoverServersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DiscoverServersSecurityOption2$outboundSchema: z.ZodMiniType<
  DiscoverServersSecurityOption2$Outbound,
  DiscoverServersSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function discoverServersSecurityOption2ToJSON(
  discoverServersSecurityOption2: DiscoverServersSecurityOption2,
): string {
  return JSON.stringify(
    DiscoverServersSecurityOption2$outboundSchema.parse(
      discoverServersSecurityOption2,
    ),
  );
}

/** @internal */
export type DiscoverServersSecurity$Outbound = {
  Option1?: DiscoverServersSecurityOption1$Outbound | undefined;
  Option2?: DiscoverServersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DiscoverServersSecurity$outboundSchema: z.ZodMiniType<
  DiscoverServersSecurity$Outbound,
  DiscoverServersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DiscoverServersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DiscoverServersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function discoverServersSecurityToJSON(
  discoverServersSecurity: DiscoverServersSecurity,
): string {
  return JSON.stringify(
    DiscoverServersSecurity$outboundSchema.parse(discoverServersSecurity),
  );
}

/** @internal */
export type DiscoverServersRequest$Outbound = {
  include_deleted: boolean;
  updated_since?: string | undefined;
  search?: string | undefined;
  version?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DiscoverServersRequest$outboundSchema: z.ZodMiniType<
  DiscoverServersRequest$Outbound,
  DiscoverServersRequest
> = z.pipe(
  z.object({
    includeDeleted: z._default(z.boolean(), false),
    updatedSince: z.optional(z.string()),
    search: z.optional(z.string()),
    version: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 25),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      includeDeleted: "include_deleted",
      updatedSince: "updated_since",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function discoverServersRequestToJSON(
  discoverServersRequest: DiscoverServersRequest,
): string {
  return JSON.stringify(
    DiscoverServersRequest$outboundSchema.parse(discoverServersRequest),
  );
}
